import type { ICity } from '../models';

import { _CitiesStore } from './CitiesStore';
import { CityClient } from '@/shared/api';

const CitiesStore = new _CitiesStore({
  updateCities: () => CityClient.updateCities(),
});

export function useCityStore() {
  const currentCity = computed<ICity>(() => CitiesStore.getCurrentCity());
  const currentCityId = CitiesStore.currentCityId;
  const cities = CitiesStore.getCities();

  const hasCurrentCityCourierDelivery = computed(() => {
    return CitiesStore.hasCurrentCityCourierDelivery();
  });

  const currentCenter = computed(() => CitiesStore.getCurrentCityCenterCoord());

  function setCurrentCityId(id: string) {
    return CitiesStore.setCurrentCityId(id);
  }

  async function getCitiesAsync() {
    return await CitiesStore.getCitiesAsync();
  }

  const getCities = async () => CitiesStore.getCities();

  return {
    cities,
    currentCity,
    currentCityId,
    currentCenter,
    hasCurrentCityCourierDelivery,
    setCurrentCityId,
    getCitiesAsync,
    getCities,
  };
}
